export default __webpack_public_path__ + "static/media/PF_04.6cd05291.png";